import { z } from 'zod'

// Zod schemas for Tavily API
export const TavilySearchResultSchema = z.object({
    title: z.string().describe('The title of the search result'),
    url: z.string().url().describe('The URL of the search result'),
    content: z.string().describe('The main content/snippet of the search result'),
    score: z.number().describe('Relevance score of the result'),
    raw_content: z.string().nullable().optional().describe('Optional raw content of the result')
})

export const TavilySearchResponseSchema = z.object({
    query: z.string().describe('The original search query'),
    answer: z.string().optional().describe('AI-generated answer based on search results'),
    images: z.array(z.object({
        url: z.string().url().describe('URL of the image'),
        description: z.string().optional().describe('Optional description of the image')
    })).describe('Array of relevant images found'),
    results: z.array(TavilySearchResultSchema).describe('Array of search results'),
    response_time: z.number().describe('Time taken to process the search request')
})

// Schema for Tavily search
export const TavilySearchParamsSchema = z
    .object({
        query: z
            .string()
            .describe('The search query to execute'),
        topic: z
            .enum(['general', 'news'])
            .default('general')
            .describe('Topic category for the search'),
        search_depth: z
            .enum(['basic', 'advanced'])
            .default('basic')
            .describe('Depth of search to perform'),
        max_results: z
            .number()
            .min(1)
            .max(20)
            .default(5)
            .describe('Maximum number of results to return (1-20)'),
        include_answer: z
            .boolean()
            .default(true)
            .describe('Whether to include an AI-generated answer'),
        include_raw_content: z
            .boolean()
            .default(false)
            .describe('Whether to include raw content in results'),
        time_range: z
            .enum(['day', 'week', 'month', 'year', 'd', 'w', 'm', 'y'])
            .optional()
            .describe('Optional time range for results'),
        include_domains: z
            .array(z.string())
            .optional()
            .describe('Optional list of domains to include'),
        exclude_domains: z
            .array(z.string())
            .optional()
            .describe('Optional list of domains to exclude')
    })

export type TavilySearchParams = z.infer<typeof TavilySearchParamsSchema>
export type TavilySearchResponse = z.infer<typeof TavilySearchResponseSchema>